<template>
  <div class="edit-retailer">
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"
          ><strong>{{ $t("retailer") }}</strong></mdb-card-title
        >
      </mdb-card-header>
      <mdb-card-body>
        <GooglePlaces
          v-on:place-result="placeResult"
          :searchLabel="$t('retailer_gp_search')"
          :mode="['establishment','address']"
        />
        <Address :address="address" />
        <hr />
        <p class="h5">{{ $t("retailer_chain") }}</p>
        <mdb-switch
          :offLabel="$t('retailer_chain_existing')"
          onLabel=""
          v-model="isInChain"
          @getValue="getRetailerChainState"
        />
        <ChainSelection
          v-if="isInChain"
          v-on:member="member"
          v-on:chainid="setretailerChain"
          :content="retailer"
          :memberVisibility="false"
        />
        <p class="text-left">
          {{ this.marker.position.lat }},{{ this.marker.position.lng }}
        </p>
        <mdb-row>
          <mdb-col md="12">
            <GoogleMap
              v-on:marker-moved="markerMoved"
              :marker="computedMarker"
              class="google-map"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-5">
          <mdb-col md="3">
            <mdb-btn
              @click="saveRetailer"
              color="indigo"
              class="white-text"
              icon="paper-plane"
              >{{ $t("save") }}
            </mdb-btn>
          </mdb-col>
          <mdb-col md="3">
            <mdb-btn
              @click="archiveRetailer"
              color="indigo"
              class="white-text"
              icon="paper-plane"
            >
              {{ $t("archive") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
  mdbSwitch,
} from "mdbvue";
import ChainSelection from "./ChainSelection.vue";
import GoogleMap from "./GoogleMap.vue";
import GooglePlaces from "./GooglePlaces.vue";
import Address from "./Address.vue";
export default {
  name: "EditRetailer",
  components: {
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    mdbSwitch,
    ChainSelection,
    GoogleMap,
    GooglePlaces,
    Address,
  },
  props: {
    notificationType: String,
    defaultMarker: Object,
  },
  computed: {
    computedMarker() {
      return this.marker;
    },
  },
  methods: {
    getRetailerChainState(val) {
      this.isInChain = val;
      this.isInChain ? null : (this.retailerChainId = 0);
    },
    archiveRetailer() {
      this.selectedIds.push(this.getRetailerId());
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        [this.archiveparam]: this.selectedIds,
      });
      this.$http
        .post(this.archivecontentpath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("archive_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
            this.$router.push("/retailers");
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("archive_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
    placeResult(place) {
      let addrlist = place.formatted_address.split(",")
      let postaladdr = addrlist[1].split(" ")
      this.address = {
        name: place.name,
        addr1: addrlist[0],
        zipcode: postaladdr[1],
        town: postaladdr[2],
        tel: place.international_phone_number,
        url: place.website,
      }
      this.setMarkerPosition(
        place.geometry.location.lat(),
        place.geometry.location.lng()
      );
      //this.b  ();
      this.createMarker();
    },
    loadRetailer() {
      if (!this.isNewRetailer()) {
        this.getRetailer(this.getRetailerId());
      } else {
        this.loadReady = true;
      }
    },
    getRetailerId() {
      try {
        return parseInt(this.$route.path.match(/(\d+)/)[0]);
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    isNewRetailer() {
      return this.getRetailerId() === 0;
    },
    createMarker() {
      var marker = {
        name: "Position",
        position: {
          lat: Number(this.marker.position.lat),
          lng: Number(this.marker.position.lng),
        },
        radius: Number(this.marker.radius),
      };
      this.marker = marker;
    },
    markerMoved(val) {
      this.setMarkerPosition(val.getPosition().lat(), val.getPosition().lng());
      this.createMarker();
    },
    setretailerChain(val) {
      this.retailerChainId = val;
    },
    member(member) {
      this.setMarkerPosition(member.lat, member.lng);
      this.createMarker();
    },
    setMarkerPosition(lat, lng) {
      this.marker.position.lat = lat;
      this.marker.position.lng = lng;
    },
    fillLocalRetailer(retailer) {
      this.retailer = retailer;
      this.retailerChainId = retailer.retailerchain.id;
      this.member({
        retailerChainId: this.retailerChainId,
        lat: retailer.lat,
        lng: retailer.lng,
      });
      this.retailerChainId == 0 ? (this.isInChain = false) : (this.isInChain = true);
      this.setAddress(retailer);
    },
    setAddress(retailer) {
      this.address = {
        name: retailer.name,
        addr1: retailer.addr1,
        zipcode: retailer.zipcode,
        town: retailer.town,
        email: retailer.email,
        tel: retailer.tel,
        url: retailer.url,
      };
    },
    getRetailer(id) {
      this.$notify.info({
        message: this.$t("loading_retailer"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(this.getretailerpath + id)
        .then((response) => {
          if (response.status == 200) {
            this.fillLocalRetailer(response.data.retailers[0]);
            this.loadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    saveRetailer() {
      try {
        this.postData = {
          sessionid: this.$store.getters.getToken,
          id: this.getRetailerId(),
          name: this.ifEmptyStr(this.address.name),
          addr1: this.ifEmptyStr(this.address.addr1),
          zipcode: this.ifEmptyStr(this.address.zipcode),
          town: this.ifEmptyStr(this.address.town),
          lat: this.marker.position.lat,
          lng: this.marker.position.lng,
          tel: this.ifEmptyStr(this.address.tel),
          email: this.ifEmptyStr(this.address.email),
          retailerchain_id: this.ifEmptyNbr(this.retailerChainId),
          url: this.ifEmptyStr(this.address.url),
        };
        console.log(this.postData);
        this.$http
          .post(this.editretailerpath, JSON.stringify(this.postData))
          .then((response) => {
            if (response.status == 200) {
              this.$notify.success({
                message: this.$t("adding_notification_success"),
                position: "top right",
                timeOut: this.$store.state.notifytimeoutshort,
              });
              this.$router.push("/retailers");
            }
            this.$emit("modal-ok");
          })
          .catch((error) => {
            this.$notify.error({
              message: this.$t("adding_notification_not_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
            this.$emit("modal-ok");
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.loadRetailer();
  },
  data() {
    return {
      editretailerpath: "/1.0/front/retailer",
      getretailerpath: "/1.0/front/retailer/",
      address: {},
      retailer: null,
      marker: this.defaultMarker,
      retailerChainId: 0,
      loadReady: false,
      isInChain: false,
      archivecontentpath: "2.0/newbe/retailer/deleteretailers",
      archiveparam: "retailerids",
      selectedIds: [],
    };
  },
};
</script>

<style></style>
